import { Tooltip } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const CustomTooltipStyle = createGlobalStyle`
  .renderbus-ui--tooltip {
    line-height: 1 !important;
  }
  .ant-tooltip {
    max-width: 700px !important;
  }
`;
export const StyledTooltip = styled(Tooltip)`
  .ant-tooltip.renderbus-ui--tooltip {
    max-width: 700px !important;
    .ant-tooltip-arrow {
      height: 20px;
      left: 10px !important;
    }
  }
`;
